import { Button, Image } from 'antd';
import React from 'react';
import { IoChatbubbleOutline } from "react-icons/io5";
import { MdOutlineSpaceDashboard } from "react-icons/md";
import { utility } from '../../../Utility';
import { BellFilled } from '@ant-design/icons';
import { GiHamburgerMenu } from 'react-icons/gi';



const DashboardHeader = ({ setHamburgerMenu, hamburgerMenu }) => {
    const user = JSON.parse(localStorage.getItem("admin"))
    return (
        <div className='flex justify-between items-center h-full px-4'>
                <div>
                    <span className='text-white font-medium flex items-center gap-5'>
                        {/* {!hamburgerMenu ? <Image src={'logo'} alt='logo' width={100} preview={false} /> : <></>} */}
                           <GiHamburgerMenu
                    className='cursor-pointer text-[20px]'
                    onClick={() => setHamburgerMenu(!hamburgerMenu)}
                />
                        {console.log(user,'user')}
                        Welcome! {user?.name}
                    </span>
                    {/* <GiHamburgerMenu
                    className='cursor-pointer text-[20px]'
                    onClick={() => setHamburgerMenu(!hamburgerMenu)}
                /> */}
                </div>
            <div>
                <p className='text-white font-semibold text-lg'>Liqteq Chat Admin Panel</p>
            </div>
            <div className='flex items-center gap-3'>
                {/* <Button
                    onClick={() => {
                        utility.navigate("/dashboard")
                    }}
                    className='shadow-none border-none text-[10px] p-2 text-custom-error-400 font-medium flex items-center gap-1 bg-blue-400 text-white'>
                    <MdOutlineSpaceDashboard className='text-[15px]' />
                    Dashboard
                </Button>
                <Button
                    onClick={() => {
                        utility.navigate("/invoice")
                    }}
                    className='shadow-none border-none text-[10px] p-2 text-custom-error-400 font-medium flex items-center gap-1 bg-blue-400 text-white'>
                    <MdOutlineSpaceDashboard className='text-[15px]' />
                    Invoice
                </Button> */}
                {/* <Button
                    onClick={() => {
                        utility.navigate("/chat")
                    }}
                    className='shadow-none border-none text-[10px] p-2 text-custom-error-400 font-medium flex items-center gap-1 bg-blue-400 text-white'>
                    <IoChatbubbleOutline className='text-[15px]' />
                    Live Room
                </Button> */}
                {/* <Button
                    onClick={() => {
                        utility.navigate("/")
                        localStorage.clear()
                    }}
                    className='shadow-none border-none text-[10px] p-2 text-custom-error-400 font-medium flex items-center gap-3 bg-red-400 text-white'>
                    Logout
                </Button> */}
            </div>
        </div>
    )
}

export default DashboardHeader